export function applyClose(state, data) {
  state.salesStep = data;
}
